export type ToastFlavor = 'ping' | 'success' | 'fail' | 'info';

const LIFETIME_MS = 2500;

/** Lightweight toast queue that fades each toast in and out. */
export class Toast {
  private container: HTMLElement;

  constructor(container: HTMLElement) {
    this.container = container;
  }

  show(text: string, flavor: ToastFlavor = 'info'): void {
    const el = document.createElement('div');
    el.className = `toast toast-${flavor}`;
    el.textContent = text;
    this.container.appendChild(el);

    // Trigger CSS transition on next frame.
    requestAnimationFrame(() => {
      el.classList.add('toast-show');
    });

    window.setTimeout(() => {
      el.classList.remove('toast-show');
      window.setTimeout(() => el.remove(), 300);
    }, LIFETIME_MS);
  }
}
